import { render, staticRenderFns } from "./SysRoleList.vue?vue&type=template&id=4dbe7ae0&scoped=true&"
import script from "./SysRoleList.vue?vue&type=script&lang=js&"
export * from "./SysRoleList.vue?vue&type=script&lang=js&"
import style0 from "./SysRoleList.vue?vue&type=style&index=0&id=4dbe7ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbe7ae0",
  null
  
)

export default component.exports